// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Enviar',
    stop: 'Parar',
    attach: 'Anexar ficheiros',
    add: 'Adicionar',
    upload_files: 'Carregar ficheiros',
  },
  attachment: {
    uploading: 'A carregar {{percent}}%',
    uploading_file: 'A carregar {{name}}',
    retry: 'Tentar novamente',
    remove: 'Remover {{name}}',
    cancel: 'Cancelar o carregamento de {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Em espera',
    running: 'Em execução',
    done: 'Concluído',
    failed: 'Falhou',
    denied: 'Recusado',
    background: 'Em segundo plano',
    summary_one: '{{count}} passo',
    summary_other: '{{count}} passos',
    failed_count_one: '{{count}} falharam',
    failed_count_other: '{{count}} falharam',
    retried_one: '{{count}} falhou e foi repetido',
    retried_other: '{{count}} falharam e foram repetidos',
  },
  question: {
    suggested: 'Sugerido',
    withdrawn: 'Já não é necessário',
  },
  thread: {
    live_on: 'Online em {{domain}}',
    unread_one: '{{count}} novas',
    unread_other: '{{count}} novas',
    working: 'A trabalhar nisso',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Concluído',
    running: 'Em curso',
    waiting: 'Requer atenção',
    failed: 'Falhou',
    pending: 'Ainda não',
    skipped: 'Ignorado',
  },
  lightbox: {
    enlarge: 'Ampliar: {{label}}',
    close: 'Fechar',
  },
};
